<template>
  <v-dialog
      v-model="dialog"
      max-width="600px"
      @click:outside="sendClosePopup"
  >
    <v-card>
      <v-card-title class="d-flex justify-center popup-title">
        <span class="text-h4">Bize referans olur musunuz?</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <p class="popup-text">
            Memnuniyetiniz referansımız olsun. <br> <b>HEDİYE SMS</b>’leriniz bol olsun
            <span class="emoji">😀</span>
          </p>
          <v-row class="d-flex justify-center align-center">
            <v-col lg="9">
              <v-btn
                  color="success"
                  elevation="2"
                  x-large
                  class="w-100"
                  @click="setForm"
              >
                Tabi ki...
              </v-btn>
            </v-col>

            <v-col lg="9" class="mt-4">
              <v-btn
                  color="secondary"
                  outlined
                  x-large
                  class="w-100 popup-cancel"
                  @click="sendClosePopup"
              >
                Evet ama şu anda biraz işim var
              </v-btn>
            </v-col>
            <v-col lg="8" style="margin-top: -20px;">
              <v-checkbox
                  v-model="checkbox"
                  label="Bu mesajı bir daha gösterme"
                  @change="onDontShow($event)"
                  color="gray"
                  class="popup-cancel-checkbox"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {getStorage, setStorage} from "@/views/Functions/Storage";
import {mapActions} from "vuex";
import Vue from "vue";


export default {
  name: "Popup",
  data: () => ({
    dialog: false,
    dontShow: false,
    checkbox: false,
  }),
  mounted() {
    this.showPopup();
  },
  methods: {
    ...mapActions({send: 'sendBackend'}),
    onDontShow(status) {
      this.dontShow = status;
    },
    setForm() {
      this.$store.commit('updateReferenceFormStatus', {status: true});
      this.dialog = false;
    },
    sendClosePopup() {
      if (this.dontShow) {
        const apiEndpoint = this.$store.getters.apiEndpoint;
        Vue.axios({
          url: `${apiEndpoint}reference/popup`,
          data: {},
          method: 'POST',
          statusCode: 500,
        })
      }
      setStorage('reference_popup', true, 3600);
      this.dialog = false;
    },
    showPopup() {
      if (!getStorage('reference_popup')) {
        const apiEndpoint = this.$store.getters.apiEndpoint;
        Vue.axios({
          url: `${apiEndpoint}reference/popup/status`,
          data: {},
          method: 'POST',
          statusCode: 500,
        }).then((res) => {
          if (res !== undefined && res.data.data.status === 0) {
            setStorage('reference_popup', true, 3600);
            this.dialog = false;
          } else {
            this.dialog = true;
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.popup-title span {
  font-weight: bold;
  color: #68696b;
}

.popup-text {
  text-align: center;
  font-size: 16px;
  opacity: 1;
  color: #68696b;
}

.popup-text b {
  font-weight: bold;
  font-size: 18px;
  color: #000;
}

.emoji {
  font-size: 22px;
}

.popup-cancel:hover {
  background-color: gray;
  color: #fff !important;
}

.popup-cancel {
  border-color: gray;
  color: gray !important;
}
</style>